export const locale = {
  lang: 'en-CA',
  data: {
    COMBO_PANEL: {
      TITLE: 'Edit combo',
      TITLE_CREATE: 'Create combo',
      TITLE_CREATE_DYNAMIC: 'Create dynamic combo',
      LEFT_LIST_LABEL: 'Drag & drop or use the + button to add products',
      RIGHT_LIST_LABEL: 'Reorder, adjust or remove a product from the combo',
      CREATE_PRODUCT: 'Create product',
      SEARCH: 'search by internal name, external name or product code',
      SEARCH_PRODUCT: 'Perform a search for your product.',
      CATEGORY_FILTER: 'Product category',
      TAGS_FILTER: 'Tags',
      NO_SEARCH_RESULTS: 'No results for your search.',
      NO_SEARCH_RESULTS_TRY_AGAIN: 'Please try something else.',
      MULTIPLY_CHILD_QTY: 'Multiply combo children quantity',
      COMBO_SUFFIX: 'Combo',
      COMBO_DYNAMIC_SUFFIX: 'Dynamic combo',
      REMOVE_ITEM: 'Remove from combo',
    },
  },
};
